module.exports = __webpack_public_path__ + "static/img/bg_selectbox_arrow_bk.9f5762a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg_selectbox_arrow_bk.png
// module id = U4pR
// module chunks = 10